export default __webpack_public_path__ + "static/media/share.edcc8cad.svg";